<template>
<div>
    <span style="color: #868e96; font-weight: 600; font-size: 13px;">Daily size of taken Snapshots & Backups</span>
    <div style="margin-top: 37px;">
        <canvas id="snapshots-size"></canvas>
    </div>
</div>
</template>

<script>
import Chart from 'chart.js';
import Api from '@/api';

export default {
    data() {
        return {
            dailySnapshotsSize: null,
        }
    },

    mounted() {
        this.getStats();
        // this.createChart();
    },

    methods: {
        getStats() {
            Api().get('users/current/stats/snapshots-and-backups-daily-size')
            // Api().get('users/current/stats/daily-size-chart')
                .then((response) => {
                    this.dailySnapshotsSize = response.data.data;
                    this.createChart();
                })
                .catch((error) => {
                    //
                });
        },

        createChart() {
            var ctx = document.getElementById('snapshots-size');
            var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: this.dailySnapshotsSize.labels,
                    datasets: [{
                        label: 'Size in GB',
                        data: this.dailySnapshotsSize.datasets,
                        backgroundColor: [
                            'rgba(77, 171, 247, 0.2)',
                            'rgba(77, 171, 247, 0.2)',
                            'rgba(77, 171, 247, 0.2)',
                            'rgba(77, 171, 247, 0.2)',
                            'rgba(77, 171, 247, 0.2)',
                            'rgba(77, 171, 247, 0.2)',
                            'rgba(77, 171, 247, 0.2)',
                        ],
                        borderColor: [
                            'rgba(77, 171, 247, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(77, 171, 247, 1)',
                            'rgba(77, 171, 247, 1)',
                            'rgba(77, 171, 247, 1)',
                            'rgba(77, 171, 247, 1)',
                            'rgba(77, 171, 247, 1)',
                        ],
                        pointBackgroundColor: [
                            'rgba(77, 171, 247, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(77, 171, 247, 1)',
                            'rgba(77, 171, 247, 1)',
                            'rgba(77, 171, 247, 1)',
                            'rgba(77, 171, 247, 1)',
                            'rgba(77, 171, 247, 1)',
                        ],
                        borderWidth: 2,
                        pointRadius: 4,
                        pointHoverRadius: 7,
                    }]
                },
                options: {
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: false,
                                display: false,
                                max: this.maxYTick,
                            },
                            gridLines: {
                                display: false,
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                display: false,
                            },
                            gridLines: {
                                display: false,
                            }
                        }]
                    },
                    legend: {
                        display: false
                    },
                    tooltips: {
                        custom: function(tooltip) {
                            if (!tooltip)  {
                                return;
                            }
                            tooltip.displayColors = false;
                            tooltip.xPadding = 12;
                        },
                        callbacks: {
                           label: function(tooltipItem) {
                                let pieces = tooltipItem.xLabel.split('-');
                                let date = new Date(pieces[0], pieces[1] - 1, pieces[2]);
                                let month = date.toLocaleString('en-us', { month: 'long' });

                                var day = pieces[2];
                                if (day.charAt(0) == '0') {
                                    day = day.substr(1);
                                }

                                return tooltipItem.yLabel + ' GB of snapshots & backups on ' + day + ' ' + month;
                           },
                           title: function(tooltipItem, data) {
                               return;
                           }
                        }
                    },
                }
            });
        },
    },

    computed: {
        maxYTick() {
            var max = 0;

            for (var i = 0; i < this.dailySnapshotsSize.datasets.length; i++) {
                if (this.dailySnapshotsSize.datasets[i] > max) {
                    max = this.dailySnapshotsSize.datasets[i];
                }
            }

            var percent = 0.1 * max;
            
            if (percent < 1) {
                percent = 1;
            }

            return max + (parseInt(percent));
        },
    },
}
</script>
